// Local translations
export const T = {
  en_GB: {
    heightLabel: "Height (cm)",
    description: "Vertical space between components",
    validationError: "Please enter a valid height",
  },
  nb_NO: {
    heightLabel: "Høyde (cm)",
    description: "Vertikal avstand mellom komponenter",
    validationError: "Vennligst angi en gyldig høyde",
  },
} as const;
